<template>
  <a-spin :spinning="formOption.busy">
    <a-form
        ref="form"
        :form="form"
        :label-col="{ span: 12 }"
        :wrapper-col="{ span: 12 }"
    >
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="标签类型">
            <a-input v-model="tagTypeNameNew" :disabled="true"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="标签分组名称">
            <a-input v-model="groupName"/>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="save()">提交</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import {formatter as fmt} from "@/utils/form-formatter";

//接口API
import {dataApi} from '@/services/client/labelManage';

/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    groupName: {
      rules: [{required: true, whitespace: true, message: "请输入标签分组名称"}]
    },
  };
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  this.show = true
  console.log(entity)
  return fmt.formatFormLoad(entity);
}

/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save() {
  let result = {
    parentId: this.groupId,
    groupName: this.groupName
  }
  if (!this.groupName) {
    this.$message.error('请输入标签分组名称');
    return false;
  }
  this.loading(true);
  let entity = {};
  if (this.readyTodo) { //更新
    this.selectedObj.groupName = this.groupName;
    result = this.selectedObj;
    entity = await dataApi.saveFormGroupDetail(result, true); //更新
  } else {
    entity = await dataApi.saveFormGroupDetail(result); //新增
  }
  if (entity.code === 200) {
    this.$emit('cancelled');
  } else if (entity.code === 201) {
    this.$message.warn(entity.data);
  }
  this.$emit('reload');
  this.loading(false);
  this.refresh();
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  props: ['groupId', 'parentId', 'tagTypeName', 'readyTodo', 'selectedObj'],
  data() {
    return {
      show: false,
      editStatus: false,
      treeData: [],
      dealer: [],
      groupName: '',
      rules: {
        parentId: 0,
        groupId: 0,
      }
    }
  },
  computed: {
    tagTypeNameNew: function () {
      return this.readyTodo ? this.selectedObj.parentName : this.tagTypeName
    },
  },
  created() {
    if (this.readyTodo) { //更新二级标签 分组名称
      // this.tagTypeName = this.selectedObj.parentName;
      this.groupName = this.selectedObj.groupName;
    }
  },
  mounted() {
    console.log(1111)
  },
  methods: {
    loadEntity,
    save,
    getRulesTemplate,
  },
};
</script>

<style scoped lang="less">
</style>